module.exports = __webpack_public_path__ + "assets/silver.91d87695.svg";